export enum MyRewardsActionTypes {
  GET_REWARDS_BY_TRIGGER = '@my-rewards/GET_REWARDS_BY_TRIGGER',
}
